export default __webpack_public_path__ + "static/media/arabic.1895b827.mp4";